export class MenuView {
  constructor(container, { onPlay, onHowToPlay, onLeaderboard, onSignIn }) {
    this.container = container;
    this.onPlay = onPlay;
    this.onHowToPlay = onHowToPlay;
    this.onLeaderboard = onLeaderboard;
    this.onSignIn = onSignIn;

    this.element = null;
    this.playerNameEl = null;
    this.playerBadgeEl = null;
    this.guestActionContainer = null;
    this.init();
  }

  init() {
    this.element = document.createElement('div');
    this.element.className = 'ui-view menu-view hidden';
    this.element.style.justifyContent = 'center';
    this.element.style.alignItems = 'center';
    this.element.style.padding = '24px';

    const card = document.createElement('div');
    card.className = 'card-panel';
    card.style.maxWidth = '480px';
    card.style.width = '100%';
    card.style.textAlign = 'center';
    card.style.backdropFilter = 'blur(10px)';

    // Title
    const title = document.createElement('h1');
    title.className = 'text-title';
    title.textContent = 'STYLE SPRINT';
    title.style.color = 'var(--color-primary)';
    title.style.marginBottom = '6px';
    card.appendChild(title);

    // Subtitle
    const subtitle = document.createElement('p');
    subtitle.className = 'text-secondary';
    subtitle.textContent = 'Switch lanes. Grab energy. Beat your best.';
    subtitle.style.fontSize = '1.05rem';
    subtitle.style.marginBottom = '24px';
    card.appendChild(subtitle);

    // Player Identity Bar
    const playerBar = document.createElement('div');
    playerBar.style.display = 'flex';
    playerBar.style.alignItems = 'center';
    playerBar.style.justifyContent = 'center';
    playerBar.style.gap = '10px';
    playerBar.style.padding = '10px 16px';
    playerBar.style.background = 'var(--color-surface-raised)';
    playerBar.style.borderRadius = 'var(--radius-control)';
    playerBar.style.marginBottom = '24px';
    playerBar.style.border = '1px solid var(--color-border)';

    this.playerNameEl = document.createElement('span');
    this.playerNameEl.style.fontWeight = '700';
    this.playerNameEl.textContent = 'Runner';

    this.playerBadgeEl = document.createElement('span');
    this.playerBadgeEl.className = 'badge badge-guest';
    this.playerBadgeEl.textContent = 'Guest';

    playerBar.appendChild(this.playerNameEl);
    playerBar.appendChild(this.playerBadgeEl);
    card.appendChild(playerBar);

    // Actions
    const playBtn = document.createElement('button');
    playBtn.className = 'btn-primary';
    playBtn.style.width = '100%';
    playBtn.style.padding = '16px';
    playBtn.style.fontSize = '1.25rem';
    playBtn.style.marginBottom = '12px';
    playBtn.textContent = '▶ PLAY';
    playBtn.onclick = () => this.onPlay();
    card.appendChild(playBtn);

    const btnRow = document.createElement('div');
    btnRow.style.display = 'grid';
    btnRow.style.gridTemplateColumns = '1fr 1fr';
    btnRow.style.gap = '12px';
    btnRow.style.marginBottom = '16px';

    const htpBtn = document.createElement('button');
    htpBtn.className = 'btn-secondary';
    htpBtn.textContent = 'How to Play';
    htpBtn.onclick = () => this.onHowToPlay();
    btnRow.appendChild(htpBtn);

    const lbBtn = document.createElement('button');
    lbBtn.className = 'btn-secondary';
    lbBtn.textContent = 'Leaderboard';
    lbBtn.onclick = () => this.onLeaderboard();
    btnRow.appendChild(lbBtn);

    card.appendChild(btnRow);

    // Guest Sign In Container
    this.guestActionContainer = document.createElement('div');
    const signInBtn = document.createElement('button');
    signInBtn.className = 'btn-text';
    signInBtn.textContent = 'Sign in with Start.ng';
    signInBtn.onclick = () => this.onSignIn();
    this.guestActionContainer.appendChild(signInBtn);
    card.appendChild(this.guestActionContainer);

    this.element.appendChild(card);
    this.container.appendChild(this.element);
  }

  updatePlayer(playerInfo) {
    if (!playerInfo) return;
    const { status, player } = playerInfo;

    // Use textContent for strict XSS prevention
    this.playerNameEl.textContent = player?.name || 'Runner';

    if (status === 'signed-in') {
      this.playerBadgeEl.className = 'badge badge-signed-in';
      this.playerBadgeEl.textContent = player?.handle ? `@${player.handle}` : 'Signed in';
      this.guestActionContainer.style.display = 'none';
    } else {
      this.playerBadgeEl.className = 'badge badge-guest';
      this.playerBadgeEl.textContent = 'Guest';
      this.guestActionContainer.style.display = 'block';
    }
  }

  show() {
    this.element.classList.remove('hidden');
  }

  hide() {
    this.element.classList.add('hidden');
  }
}
